import {
  Avatar,
  Box,
  Center,
  Divider,
  Flex,
  Grid,
  GridItem,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useNavigate } from "react-router-dom";
import autostore from "../../img/autostories.svg";
import empty from "../../img/emptystate1.svg";
import engineering from "../../img/engring.png";
import trainees from "../../img/trainees.svg";
import trophy from "../../img/trophy.svg";

import TrDashboardHeader from "../../components/common/TrainerDashboardHeader";
import { IUser } from "../../models/auth.model";
import { ITrDashboard } from "../../models/dashboard/trainer-dashboard";
import { getLocalUserProfile } from "../../services/auth.service";
import trainerbioService from "../../services/trainer/trainerbio.service";
import trainerRoutes from "./routes";
import Loading from "../../components/common/Loading";
//import 'react-calendar/dist/Calendar.css';
const TrainerDashboard = () => {
  const [userProfile, setUserProfile] = useState<IUser | null>();
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [dashboard, setDashboard] = useState<ITrDashboard>();

  useEffect(() => {
    trainerbioService
      .getTrainersDashbord()
      .then((response) => {
        setDashboard(response.data);
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const user = getLocalUserProfile();
    setUserProfile(user);
  }, []);
  const data = [
    {
      name: "Mon",
      Hours: 3,

      amt: 2400,
    },
    {
      name: "Tue",
      Hours: 2,

      amt: 2210,
    },
    {
      name: "Wed",
      Hours: 5,

      amt: 2290,
    },
    {
      name: "Thur",
      Hours: 1,
      amt: 2000,
    },
    {
      name: "Friday",
      Hours: 2,

      amt: 2181,
    },
  ];

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <TrDashboardHeader />
          <Flex
            height="100%"
            bg="#F9F8F8"
            pt="50px"
            pb={{ lg: "120px", md: "100px", sm: "80px" }}
            px="5%"
            justifyContent="space-around"
            width="100%"
            flexDirection={{
              lg: "row",
              md: "row",
              sm: "column",
              base: "column",
            }}
            margin={{ sm: "0 auto", base: "0 auto" }}
          >
            <Flex
              width={{ lg: "75%", md: "75%", sm: "100%%", base: "100%" }}
              flexDirection="column"
            >
              <Box width={{ lg: "90%", md: "90%" }}>
                <Grid
                  bg="white"
                  padding="1rem"
                  mt="40px"
                  gap="1rem"
                  boxShadow="md"
                  rounded="lg"
                  mb="40px"
                  templateColumns="repeat(5, auto)"
                  justifyContent="space-around"
                  height={"auto"}
                >
                  <GridItem
                    gap="8px"
                    textAlign="center"
                    display={"flex"}
                    justifyContent={"space-between"}
                    flexDirection={{
                      lg: "column",
                      md: "column",
                      sm: "column",
                      base: "column",
                    }}
                  >
                    <Image
                      src={autostore}
                      margin="0 auto"
                      width={{
                        lg: "auto",
                        md: "auto",
                        sm: "25px",
                        base: "25px",
                      }}
                      height={{
                        lg: "50px",
                        md: "50px",
                        sm: "24px",
                        base: "24px",
                      }}
                    />
                    <Box>
                      <Text
                        fontSize={{
                          lg: "22px",
                          md: "20px",
                          sm: "16px",
                          base: "16px",
                        }}
                        color="black"
                        fontWeight="600"
                      >
                        {dashboard && dashboard?.courses.length}
                      </Text>
                      <Text
                        fontSize={{
                          lg: "20px",
                          md: "17px",
                          sm: "12px",
                          base: "12px",
                        }}
                      >
                        Courses Assigned{" "}
                      </Text>
                    </Box>
                  </GridItem>
                  <Divider color="gray.200" orientation="vertical" />
                  <GridItem
                    gap="8px"
                    textAlign="center"
                    display={"flex"}
                    justifyContent={"space-between"}
                    flexDirection={{
                      lg: "column",
                      md: "column",
                      sm: "column",
                      base: "column",
                    }}
                  >
                    <Image
                      src={trainees}
                      margin="0 auto"
                      width={{
                        lg: "auto",
                        md: "auto",
                        sm: "25px",
                        base: "25px",
                      }}
                      height={{
                        lg: "50px",
                        md: "50px",
                        sm: "24px",
                        base: "24px",
                      }}
                    />
                    <Box>
                      <Text
                        fontSize={{
                          lg: "22px",
                          md: "20px",
                          sm: "16px",
                          base: "16px",
                        }}
                        color="black"
                        fontWeight="600"
                      >
                        {dashboard?.trainees}
                      </Text>
                      <Text
                        fontSize={{
                          lg: "20px",
                          md: "17px",
                          sm: "12px",
                          base: "12px",
                        }}
                      >
                        Trainees
                      </Text>
                    </Box>
                  </GridItem>

                  <Divider color="gray.200" orientation="vertical" />
                  <GridItem
                    gap="8px"
                    textAlign="center"
                    display={"flex"}
                    justifyContent={"space-between"}
                    flexDirection={{
                      lg: "column",
                      md: "column",
                      sm: "column",
                      base: "column",
                    }}
                  >
                    <Image
                      src={trophy}
                      margin="0 auto"
                      width={{
                        lg: "auto",
                        md: "auto",
                        sm: "25px",
                        base: "25px",
                      }}
                      height={{
                        lg: "50px",
                        md: "50px",
                        sm: "24px",
                        base: "24px",
                      }}
                    />
                    <Box>
                      <Text
                        fontSize={{
                          lg: "22px",
                          md: "20px",
                          sm: "16px",
                          base: "16px",
                        }}
                        color="black"
                        fontWeight="600"
                      >
                        {dashboard?.nextTrainerLevel.name}
                      </Text>
                      <Text
                        fontSize={{
                          lg: "20px",
                          md: "17px",
                          sm: "12px",
                          base: "12px",
                        }}
                      >
                        Trainer Level
                      </Text>
                    </Box>
                  </GridItem>
                </Grid>
                <Box
                  width="100%"
                  bg="white"
                  mb="40px"
                  boxShadow="md"
                  rounded="lg"
                  mx={{ sm: "auto", base: "auto" }}
                >
                  <Flex
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="12px"
                    pt="15px"
                    mb="12px"
                    borderBottom="2px solid"
                    borderColor="gray.200"
                    justifyContent="space-between"
                  >
                    <Text
                      fontSize="18px"
                      fontWeight="600"
                      lineHeight="25px"
                      color="#616161"
                    >
                      In Progress
                    </Text>
                  </Flex>

                  {dashboard && dashboard.courses.length > 0 ? (
                    dashboard.courses.slice(0, 1).map((each, index) => (
                      <Flex
                        key={index}
                        mx="auto"
                        width="87%"
                        bg="white"
                        pb="1.6rem"
                        pt="0.5rem"
                        cursor="pointer"
                        justifyContent="space-between"
                        flexDirection={{
                          lg: "row",
                          md: "column",
                          sm: "column",
                          base: "column",
                        }}
                        onClick={() =>
                          navigate(
                            trainerRoutes.trainerCourses.CourseInformationLink(
                              each.uuid
                            )
                          )
                        }
                      >
                        <Box
                          width={{
                            lg: "47%",
                            md: "100%",
                            sm: "100%",
                            base: "100%",
                          }}
                        >
                          {each.cover_image ? (
                            <Image
                              objectFit="contain"
                              width="100%"
                              height={["200px","300px"]}
                              src={each.cover_image}
                            />
                          ) : (
                            <Image
                              objectFit="cover"
                              width="100%"
                              height={["200px","300px"]}
                              src={engineering}
                            />
                          )}
                        </Box>
                        <Box
                          width={{
                            lg: "47%",
                            md: "100%%",
                            sm: "100%",
                            base: "100%",
                          }}
                        >
                          <Text
                            color="black"
                            fontSize={{
                              lg: "22px",
                              md: "20px",
                              sm: "18px",
                              base: "18px",
                            }}
                            fontWeight="600"
                            mb="21px"
                            mt={{
                              lg: "0px",
                              md: "10px",
                              sm: "12px",
                              base: "12px",
                            }}
                          >
                            {each.name}
                          </Text>
                          <Text
                            color="#9E9E9E"
                            fontSize={{
                              lg: "14px",
                              md: "13px",
                              sm: "12px",
                              base: "12px",
                            }}
                            fontWeight="400"
                            mb="21px"
                          >
                            {each.description
                              ? each.description.substring(0, 200)
                              : "Nil"}
                          </Text>
                        </Box>
                      </Flex>
                    ))
                  ) : (
                    <Flex
                      mx="auto"
                      width="87%"
                      bg="white"
                      pb="12px"
                      pt="15px"
                      justifyContent="center"
                    >
                      <Box pb="1.4rem">
                        <Box mx="auto" width={"70px"} height="100px">
                          <Image src={empty} />
                        </Box>
                        <Text
                          textAlign="center"
                          fontWeight="600"
                          fontSize="30px"
                          color="#353535"
                        >
                          No Courses
                        </Text>
                        <Text
                          color="#353535"
                          textAlign="center"
                          fontSize="14px"
                        >
                          You have not been assigned a course yet
                        </Text>
                      </Box>
                    </Flex>
                  )}
                </Box>
                <Box
                  width="100%"
                  mb="40px"
                  bg="white"
                  boxShadow="md"
                  rounded="lg"
                  mx={{ sm: "auto", base: "auto" }}
                >
                  <Flex
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="12px"
                    pt="15px"
                    mb="36px"
                    borderBottom="2px solid"
                    borderColor="gray.200"
                    justifyContent="space-between"
                  >
                    <Text
                      fontWeight="600"
                      fontSize="18px"
                      lineHeight="25px"
                      color="#616161"
                    >
                      Assigned Courses
                    </Text>
                    <Link
                      fontWeight="500"
                      color="#EC3337"
                      fontSize="16px"
                      onClick={() => {
                        navigate(trainerRoutes.trainerCourses.mycourses);
                      }}
                    >
                      See All
                    </Link>
                  </Flex>
                  {dashboard && dashboard.courses.length > 0 ? (
                    <Grid
                      templateColumns={{
                        lg: "repeat(3, 1fr)",
                        md: "repeat(2, 1fr)",
                        sm: "repeat(1, 1fr)",
                        base: "repeat(1, 1fr)",
                      }}
                      mx="auto"
                      width="87%"
                      bg="white"
                      justifyContent="space-between"
                      pb="40px"
                      gap="0.6rem"
                    >
                      {dashboard.courses.slice(0, 3).map((each, index) => (
                        <GridItem
                          key={index}
                          width="100%"
                          boxShadow="0px 3.50207px 7.87967px rgba(51, 49, 49, 0.09)"
                          bg="white"
                        >
                          {each.cover_image ? (
                            <Image
                              objectFit="cover"
                              width="100%"
                              objectPosition="center"
                              height="170px"
                              src={each.cover_image}
                            />
                          ) : (
                            <Image
                              objectFit="cover"
                              objectPosition="center"
                              height="170px"
                              width="100%"
                              src={engineering}
                            />
                          )}
                          <Box width="90%" mx="auto" mt="21px" mb="27px">
                            <Text
                              mb="15px"
                              color="#616161"
                              fontSize="14px"
                              fontWeight="400"
                            >
                              {each.name.substring(0, 40)}...
                            </Text>
                            <Text
                              mb="15px"
                              color="#616161"
                              fontSize="14px"
                              fontWeight="400"
                            >
                              {each.description
                                ? each.description.substring(0, 60)
                                : "Nil"}
                              ...
                            </Text>
                          </Box>
                        </GridItem>
                      ))}
                    </Grid>
                  ) : (
                    <Center padding="2rem" width="100%">
                      <Box margin="0 auto">
                        <Box mx="auto" width={"70px"} height="100px">
                          <Image src={empty} />
                        </Box>
                        <Text
                          textAlign="center"
                          fontWeight="600"
                          fontSize="30px"
                          color="#353535"
                        >
                          No Courses
                        </Text>
                        <Text
                          color="#353535"
                          textAlign="center"
                          fontSize="14px"
                        >
                          You have not been assigned a course yet
                        </Text>
                      </Box>
                    </Center>
                  )}
                </Box>
              </Box>
            </Flex>
            <Box
              mr="88px"
              width={{ lg: "25%", md: "25%", sm: "100%", base: "100%" }}
            >
              <Flex
                mb="30px"
                display={{ lg: "flex", md: "flex", sm: "none", base: "none" }}
                margin={{ sm: "2rem auto", base: "2rem auto" }}
                flexDirection="column"
                width={{ lg: "100%", md: "18rem", sm: "93%", base: "93%" }}
                height={{
                  lg: "350px",
                  md: "18rem",
                  sm: "270px",
                  base: "270px",
                }}
                justifyContent="center"
                bg="white"
                boxShadow="md"
                rounded="lg"
              >
                <Avatar
                  mx="auto"
                  width="100px"
                  height="100px"
                  borderRadius="50px"
                  name={userProfile?.name}
                ></Avatar>
                <Text mx="auto" fontSize="20px" fontWeight="500">
                  {userProfile?.name}
                </Text>
                <Text mx="auto" fontSize="13px" color="#9E9E9E" mb="20px">
                  TNE-{userProfile?.uuid.substring(0, 10)}
                </Text>
                <Text
                  mx="auto"
                  fontSize="15px"
                  color="#EC3337"
                  cursor="pointer"
                  onClick={() => navigate(trainerRoutes.trainerProfile)}
                >
                  Update Profile
                </Text>
              </Flex>
              <Box
                mb="30px"
                display={{ lg: "block", md: "block", sm: "none", base: "none" }}
                width={{ lg: "100%", md: "18rem", sm: "100%", base: "100%" }}
                boxShadow="md"
                rounded="lg"
              >
                <Calendar onChange={setDate} value={date} />
              </Box>
              <Flex
                flexDirection="column"
                width={{ lg: "100%", md: "18rem", sm: "93hw", base: "93hw" }}
                height="350px"
                pt="25px"
                bg="white"
                boxShadow="md"
                rounded="lg"
              >
                <Text
                  mx="auto"
                  pb="25px"
                  fontWeight="600"
                  fontSize="18px"
                  lineHeight="25px"
                  color="#616161"
                >
                  Upcoming Task
                </Text>
                <Box
                  mx="auto"
                  minWidth="250px"
                  mb="10px"
                  minHeight="55px"
                  bg="#F9F8F8"
                >
                  <Box p="15px">
                    <Text>Field work at Ikeja</Text>
                    <Text color="#9E9E9E" fontSize="13px">
                      By 8:00am
                    </Text>
                  </Box>
                </Box>
                <Box
                  mx="auto"
                  minWidth="250px"
                  mb="10px"
                  minHeight="55px"
                  bg="#F9F8F8"
                >
                  <Box p="15px">
                    <Text>Electrical Maintenance Lecture</Text>
                    <Text color="#9E9E9E" fontSize="13px">
                      By 3:00pm
                    </Text>
                  </Box>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </>
      )}
    </>
  );
};

export default TrainerDashboard;
